import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type Assistant = components["schemas"]["Assistant"];

/**
 * GET /v1/assistants/{id} — the assistant a new chat is scoped to. A thin
 * chat-local fn over the shared endpoint (features don't import each other); we
 * only need the assistant itself for the welcome hero + default-model bias.
 */
export async function getAssistant(id: string): Promise<Assistant> {
  const res = unwrap(
    await api.GET("/v1/assistants/{id}", { params: { path: { id } } }),
  ) as { assistant: Assistant };
  return res.assistant;
}
